import React from "react";
import { Button, ButtonGroup, FormGroup } from "@material-ui/core";
import { Col, Input, InputGroupText, Label, Row } from "reactstrap";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import {
  imageSettingsList,
  htmlSettingsList,
  videoSettings,
  exhibitorSettingsList,
  zoomSettingsList,
  breakoutSettingsList,
  blockSettingsList,
  buttonSettingsList,
  textSettingsList,
  jitsiSettings,
  groupGeneratorSettingsList,
  genericSettings,
  userCardSettingsList,
  chatSettingsList,
  vongageSettingsList,
  agendaSettings,
  countdownSettings,
  imageSourceSettinglist,
  videoWallSettingsList,
  speakerControlSettings,
  speakerCardSettings,
  speakerListSettings,
  eventNameSettings,
  contentViewSettings,
  pollModuleSettings,
  clientListSettingsList,
  presenterModule,
  plauditButtonSettings,
  plauditTrackSettings
} from "../models/defaultModuleSettings";
import UrlMultiInput from "../../components/UrlMultiInput/UrlMultiInput";
import EditorSlider from "../../components/EditorSlider/EditorSlider";
import ColorPickerFacade from "../../components/ColorPickerFacade/ColorPickerFacade";
import { templateHelper } from "../../cms/areas/template/helpers/templateHelper";
import SourceEditorBase from "./SourceEditorWindow";
import JirangoSwitch from "../../components/JirangoSwitch/JirangoSwitch";
import SettingsList from "../../cms/areas/template/components/SettingsList";
import FontPicker from "../../cms/areas/template/components/FontPicker";
import { FontWeightPicker } from "../../cms/areas/template/components/FontWeightPicker";
import Select from "react-select";
import { selectorStyle } from "../layout/other/EventSelector";
import JirangoDatepicker from "../../plugins/JirangoDatepicker";
import { ModulePlaceholder } from "../layout/Sidebar/modules/ModulePlaceholder";
import LinkMultiInput from "../../components/UrlMultiInput/LinkMultiInput";
import { MenuEditor } from "./MenuEditor";
import { PlauditIconSelector } from "./PlauditIconSelector";

const getUnit = (v) => {
  let unit = "px";
  try {
    unit = v.replace(v.replace(/[^0-9\d.-]/g, ""), "");
  } catch (error) { }

  return unit;
};

export const SettingsListItem = ({ type, label, value, onChange, events, eventId, extra = null }) => {

  switch (type.toString().toUpperCase()) {
    case "SLIDER":
      return (
        <EditorSlider
          value={parseFloat(value)}
          defaultValue={extra.defaultValue}
          unitChange={(u, p) => {
            if (extra.onUnitChange) {
              let v = extra.onUnitChange(u, value);
              onChange(v);
            }
          }}
          onChange={(s, v, p, ep) => onChange(v)}
          units={extra.units ? extra.units : []}
          activeUnit={value ? getUnit(value) : extra.activeUnit ? extra.activeUnit : null}
          attachUnit={extra.units ? true : false}
          steps={extra.steps}
          max={extra.max}
          min={extra.min}
          path={""}
          dark={true}
          label={label}
        />
      );
    case "ICON_SELECT":
      return <PlauditIconSelector eventId={eventId} onChange={onChange} value={value} label={label} />
    case "SOURCE_EDITOR":
      return <SourceEditorBase onChange={onChange} value={value} label={label} />;
    case "COLOR_PICKER":
      return (
        <Row>
          <Col className="text-left">
            <Label className="primary-text">
              <SystemLabel name={label} />
            </Label>
          </Col>
          <Col className="text-right">
            <ColorPickerFacade color={value} dark={true} onChange={(color, e) => onChange(templateHelper.parseColorToRgba(color))} path="" />
          </Col>
        </Row>
      );
    case "SWITCH":
      return (
        <Row>
          <Col className="text-left">
            <Label className="primary-text">
              <SystemLabel name={label} />
            </Label>
          </Col>
          <Col className="text-right">
            <JirangoSwitch onChange={() => onChange(!value)} isChecked={Boolean(value)} />
          </Col>
        </Row>
      );
    case "ANIMATION_GROUP":
      return (
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <div className="btn-group">
            {extra.map((e, i) => {
              return (
                <div key={i} className={"sq-btn" + (value == e.name ? " active" : "")} onClick={() => onChange(e.name)}>
                  {e.icon}
                  <span>
                    <SystemLabel name={e.label} />
                  </span>
                </div>
              );
            })}
          </div>
        </FormGroup>
      );
    case "DATE_PICKER":
      return (
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <JirangoDatepicker handleChange={(value) => onChange(+new Date(value))} dark={true} minDate={new Date()} value={value} />
        </FormGroup>
      );
    case "BUTTON_GROUP":
      return (
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <div className="btn-group">
            {extra.map((e, i) => {
              return (
                <div key={i} className={"sq-btn" + (value == e.name ? " active" : "")} onClick={() => onChange(e.name)}>
                  {e.icon}
                  <span>
                    <SystemLabel name={e.label} />
                  </span>
                </div>
              );
            })}
          </div>
        </FormGroup>
      );
    case "BUTTON_GROUP_SMALL":
      return (
        <div style={{ display: "flex" }}>
          <div style={{ textAlign: "left" }}>
            <Label className="primary-text">
              <SystemLabel name={label} />
            </Label>
          </div>
          <div style={{ marginLeft: "auto" }}>
            <ButtonGroup size="small" aria-label="small outlined button group">
              {extra.map((e, i) => {
                return (
                  <div key={i} className={"sq-btn small" + (value == e.name ? " active" : "")} onClick={() => onChange(e.name)}>
                    {e.icon}
                  </div>
                );
              })}
            </ButtonGroup>
          </div>
        </div>
      );
    case "DATE":
      return (
        <FormGroup>
          <Label>
            <SystemLabel name={label} />
          </Label>
          <Input value={value} type="datetime-local" onChange={(e) => onChange(e.target.value)} />
        </FormGroup>
      );
    case "TEXTAREA":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <Input value={value} type="textarea" style={{ minHeight: 250 }} onChange={(e) => onChange(e.target.value)} />
        </FormGroup>
      );
    case "TEXT":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <Input value={value || ""} type="text" onChange={(e) => onChange(e.target.value)} />
        </FormGroup>
      );
    case "LINK_INPUT":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <LinkMultiInput onChange={(url) => onChange(url)} margin={false} dark={true} eventId={eventId} colStyle={{ padding: 0, margin: 0 }} rowStyle={{ margin: "0px" }} url={value} />
        </FormGroup>
      );
    case "MENU_EDITOR":
      return <MenuEditor menu={value} eventId={eventId} onChange={(menu) => onChange(menu)} />;
    case "MULTI_INPUT":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <UrlMultiInput
            onChange={(url, srcset) => onChange(url, srcset, "srcset")}
            setImage={(url, srcset) => onChange(url, srcset, "srcset")}
            margin={false}
            noInfoText={true}
            dark={true}
            colStyle={{ padding: 0, margin: 0 }}
            rowStyle={{ margin: "0px" }}
            url={value}
          />
        </FormGroup>
      );
    case "FONTFAMILY_SELECT":
      return <FontPicker onChange={(s, font, p) => onChange(font)} path="" nonWrapped={true} currentFontFamily={value} />;
    case "FONTWEIGHT_SELECT":
      return <FontWeightPicker onChange={(s, w, p) => onChange(w)} path="" weight={value} />;
    case "NUMBER":
      return (
        <FormGroup className="dark-input">
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <Input value={value} type="number" steps={extra.steps} max={extra.max} min={extra.min} onChange={(e) => onChange(e.target.value)} />
        </FormGroup>
      );
    case "EVENT_SELECT":
      return (
        <FormGroup>
          <Label className="primary-text">
            <SystemLabel name={label} />
          </Label>
          <Select
            classsName="jirango-select"
            options={
              events
                ? [
                  { value: null, label: "Inget" },
                  ...events
                    .filter((e) => e.eventId != eventId)
                    .sort((a, b) => {
                      return +new Date(a.startDateTime) - +new Date(b.startDateTime);
                    })
                    .map((t) => {
                      return { value: t.eventId, label: t.name };
                    }),
                ]
                : []
            }
            value={{
              value: value,
              label: events.find((e) => e.eventId == value)?.name,
            }}
            onChange={(opt) => onChange(opt.value)}
            styles={{
              ...selectorStyle,
            }}
          />
        </FormGroup>
      );
    default:
      return null;
  }
};

const stylableModules = ["TextModule", "BlockModule", "ButtonModule", "CountdownModule", "VonageVideoClientModule", "SpeakerControl", "SpeakerCard", "EventName", "ContentView", "VideoWallModule", "PlauditButtons", "PlauditTrack"];

export const ModuleSettings = (props) => {
  const { tab, settings, onChange, type, children } = props;

  if (tab == "ContentSettings" || tab == "AdvancedSettings" || (tab == "StyleSettings" && stylableModules.includes(type))) return <Tab {...props} />;
  else if (tab == "StyleSettings") return <SettingsList type={type} />;
  return null;
};

const handleChange = (settings, value, path) => {
  if (path == "useTemplateStyle" && settings.settings) {
    settings.settings[path] = value;
  }
  if (typeof value == {}) return Object.assign({}, { ...settings, ...value });
  return Object.assign({}, { ...settings, [path]: value });
};

const Tab = (props) => {
  const { onChange, tab, type, module, children, events, eventId, mainEventId, copyModule } = props;
  const settingsList = getModuleSettings(type);
  let settings = props.settings;

  return (
    <div className="layout-list settings-list">
      <ModulePlaceholder
        type={type}
        description={<SystemLabel name={type + "Info"} />}
        customStyle={{ display: "flex", flexDirection: "row", alignItems: "center", textAlign: "left", justifyContent: "left", background: "transparent", cursor: "default" }}
      />
      <Button
        style={{
          marginTop: 5,
          marginBottom: 5,
          color: "#fff",
          backgroundColor: "#3f414c",
          width: "100%",
        }}
        startIcon={<SwapHorizIcon />}
        onClick={() => copyModule()}
      >
        <SystemLabel name="CopyAndReplace" />
      </Button>
      {tab == "ContentSettings" ? children : null}
      {settingsList
        ? settingsList
          .filter((sl) => sl.tab == tab)
          .map((s, i) => {
            if (!s.showIf || (s.showIf && settings[s.showIf.name] == s.showIf.value)) {
              return (
                <React.Fragment key={s.name + "_" + module.meetingModuleId}>
                  <div className="settings-item-wrapper ">
                    <SettingsListItem
                      {...s}
                      eventId={eventId}
                      events={events}
                      value={s.prop == "settings" ? (s.subProps ? settings[s.subProp][s.name] : settings[s.name]) : module[s.name]}
                      onChange={(value, value2, value2Prop) => {

                        if (s.prop == "settings") {
                          let newSettings = handleChange(settings, value, s.name);

                          if (value2Prop) {
                            newSettings[value2Prop] = value2;
                          }

                          onChange({
                            ...module,
                            settings: newSettings,
                          })

                        }
                        else {
                          onChange(handleChange(module, value, s.name));
                        }

                      }}
                    />
                    {s.separator ? <hr /> : null}
                  </div>
                </React.Fragment>
              );
            }
          })
        : null}
    </div>
  );
};

const getModuleSettings = (key) => {
  switch (key) {
    case "Image":
      return imageSettingsList;
    case "Html":
      return htmlSettingsList;
    case "Iframe":
      return videoSettings;
    case "Video":
      return videoSettings;
    case "ZoomFrame":
      return zoomSettingsList;
    case "Exhibitors":
      return exhibitorSettingsList;
    case "Breakouts":
      return breakoutSettingsList;
    case "SpeakerControl":
      return speakerControlSettings;
    case "BlockModule":
      return blockSettingsList;
    case "TextModule":
      return textSettingsList;
    case "JitsiFrame":
      return jitsiSettings;
    case "ButtonModule":
      return buttonSettingsList;
    case "GroupGenerator":
      return groupGeneratorSettingsList;
    case "UserCard":
      return userCardSettingsList;
    case "Chat":
      return chatSettingsList;
    case "Agenda":
      return agendaSettings;
    case "SpeakerCard":
      return speakerCardSettings;
    case "CountdownModule":
      return countdownSettings;
    case "VonageVideoClientModule":
      return vongageSettingsList;
    case "ImageMap":
      return imageSourceSettinglist;
    case "VideoWallModule":
      return videoWallSettingsList;
    case "SpeakerList":
      return speakerListSettings;
    case "EventName":
      return eventNameSettings;
    case "ContentView":
      return contentViewSettings;
    case "PollModule":
      return pollModuleSettings;
    case "ClientList":
      return clientListSettingsList;
    case "Presenter":
      return presenterModule;
    case "PlauditButtons":
      return plauditButtonSettings;
    case "PlauditTrack":
      return plauditTrackSettings;
    default:
      return genericSettings;
  }
};
